import { Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage, FormLabel, Input, Textarea, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useRegisterLineDevForm } from "../../../../hooks/externalApi/line/useRegisterLineDevForm";
import { useRegisterLineDev } from "../../../../hooks/externalApi/line/useRegisterLineDev";
import { SubmitBtn } from "../../../atoms/button/SubmitBtn";
import { DarkShadowCard } from "../../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";


export const RegisterLineDev = () => {
  const { restaurantId } = useParams();
  const { handleSubmit, register, isSubmitting, errors } = useRegisterLineDevForm()
  const onSubmit = useRegisterLineDev(restaurantId)
  const accessTokenError = errors.access_token?.message;
  const channelSecretError = errors.channel_secret?.message;
  return (
    <Box m='auto' w={{base: '100%', md: '700px'}}>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<SettingsIcon />} heading='LineDev設定'/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={5}>
              <FormControl isRequired isInvalid={!!errors.access_token} w='100%'>
                <FormLabel>アクセストークン</FormLabel>
                <Textarea {...register('access_token')} />
                <FormErrorMessage>{accessTokenError}</FormErrorMessage>
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.channel_secret} w='100%'>
                <FormLabel>チャンネルシークレット</FormLabel>
                <Input {...register('channel_secret')} />
                <FormErrorMessage>{channelSecretError}</FormErrorMessage>
              </FormControl>
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
};